<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="3">
				<!-- Plant -->
				<sf-select-group
					:label="getMessage_('SWCC000001')"
					:inputValue="plantCd"
					:options="plants"
					:onChange="value => onSelect('plantCd', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 화면 ID -->
				<sf-select-group
					:label="getMessage_('SWCC000320')"
					:inputValue="controlScrId"
					:options="controlScrIds"
					:onChange="value => onSelect('controlScrId', value)"
				/>
			</el-col>
			<el-col :span="4">
				<!-- 화면명 -->
				<sf-input-group
					:label="getMessage_('SWCC000321')"
					:inputValue="controlScrName"
					:onChange="value => onChange('controlScrName', value)"
				/>
			</el-col>
			<el-col :span="3">
				<!-- 사용자 ID -->
				<sf-input-group :label="getMessage_('SWCC000217')" :inputValue="userId" :onChange="value => onChange('userId', value)" />
			</el-col>
			<el-col :span="9">
				<!-- 제어권 획득 중인 화면만 조회 -->
				<sf-group-wrapper :label="getMessage_('SWCC000785')" :gutter="10">
					<el-row :gutter="10">
						<el-col :span="12">
							<el-checkbox @input="value => onCheck('onlyIng', value)"></el-checkbox>
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ControlManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		this.getPlant_().catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});

		this.getScreens_({ plantCd: this.plantCd }).catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
	},

	watch: {
		screen() {
			if (this.screen.defaultPageSize && this.user.plantCd) {
				this.defaultAssign_({
					key: 'groups',
					value: { currentPage: 1, pageUnit: this.screen.defaultPageSize, data: [] }
				})
					.then(() => {
						this.search();
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		}
	},

	computed: {
		...rootComputed,
		...serviceComputed,

		plantCd() {
			return this.user.plantCd;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		search() {
			this.$sf_toggleLoading(true);
			this.getControlList_({
				plantCd: this.plantCd,
				scrId: this.controlScrId,
				scrName: this.controlScrName,
				userId: this.userId,
				onlyIng: this.onlyIng,
				currentPage: 1,
				pageUnit: this.groups.pageUnit
			})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		onSelect(key, value) {
			// console.log(key, value);
			this.defaultAssign_({
				key,
				value
			});
			this.search();
		},

		onChange(key, value) {
			this.defaultAssign_({
				key,
				value
			});
		},

		onCheck(key, value) {
			if (value) this.defaultAssign_({ key, value: 'Y' });
			else this.defaultAssign_({ key, value: 'N' });
			this.search();
		}
	}
};
</script>
<style>
.right-col-content {
	padding-top: 5%;
}
.right-col-content > span {
	vertical-align: baseline;
}
.right-col-content .el-checkbox {
	margin-left: 0px;
	margin-bottom: 0px;
}
</style>
